import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Bookmark, Clock, ArrowUpRight } from "lucide-react";

const Saved = () => {
  const [favs, setFavs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/favorites")
      .then((r) => setFavs(r.data.favorites || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-10">
      <div className="overline mb-2">SAVED</div>
      <h1 className="font-serif text-4xl sm:text-5xl mb-6" data-testid="saved-title">
        Your <span className="italic text-amber-500">library.</span>
      </h1>
      <p className="text-neutral-400 max-w-xl mb-10">Chapters you've saved for later. Come back when the moment hits.</p>

      {loading ? (
        <div className="text-neutral-500" data-testid="saved-loading">Loading…</div>
      ) : favs.length === 0 ? (
        <div className="card-surface p-10 text-center" data-testid="empty-saved">
          <Bookmark className="w-8 h-8 text-amber-500 mx-auto mb-3" />
          <p className="text-neutral-300 mb-4 font-serif text-xl">No saved chapters yet.</p>
          <Link to="/library" className="btn-amber inline-flex items-center gap-2">Browse the library</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-6">
          {favs.map((a) => (
            <Link key={a.id} to={`/article/${a.id}`} className="card-surface p-8 hover-lift" data-testid={`saved-item-${a.id}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="overline text-amber-500">{a.category}</span>
                <span className="text-xs text-neutral-500 inline-flex items-center gap-1"><Clock className="w-3 h-3" /> {a.read_time} min</span>
              </div>
              <h2 className="font-serif text-2xl mb-3 leading-tight">{a.title}</h2>
              <p className="text-neutral-400 leading-relaxed">{a.excerpt}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-amber-500 text-sm">Continue reading <ArrowUpRight className="w-4 h-4" /></div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Saved;
